const quotationChat = {
  quotationChatNavLabel: "Quotation Chat",
  quotationChatApprovalTitle: "Quotation Chat",
  quotationChatAccountNotApprovedTitle: "Account Not Approved",
  quotationChatAccountNotApprovedDescription:
    "Your account is not approved yet. Please contact your account manager for further information.",
  quotationChatViewAiChat: "View A.I Chat",

  quotationRequestChatSessions: "Chat Sessions",
  quotationRequestChatNoPastSessions: "No past sessions",
  quotationRequestChatNewChat: "New Chat",
  quotationRequestChatCloseSidebar: "Close sidebar",
  quotationRequestChatSessionFallback: "Chat Session",
  quotationRequestChatDefaultSessionName: "New Chat Session",
  quotationRequestChatTitle: "Quotation Request Chat",
  quotationRequestChatResponseLanguageLabel: "Response language",
  quotationRequestChatOpenSidebar: "Open sidebar",
  quotationRequestChatRenameSession: "Rename session",
  quotationRequestChatDeleteSession: "Delete session",
  quotationRequestChatToggleDarkMode: "Toggle dark mode",
  quotationRequestChatSwitchToLightMode: "Switch to light mode",
  quotationRequestChatSwitchToDarkMode: "Switch to dark mode",
  quotationRequestChatEmptyStateHeading: "Start a New Quotation Request Conversation",
  quotationRequestChatEmptyStateSubheading:
    "Describe your travel needs and I'll create a quotation request for you.",
  quotationRequestChatMessagePlaceholderStart:
    "Type your message to start a conversation... (Shift+Enter for new line)",
  quotationRequestChatMessagePlaceholder: "Type your message... (Shift+Enter for new line)",
  quotationRequestChatUploadFile: "Upload file",
  quotationRequestChatUploadAttachment: "Upload attachment",

  quotationRequestChatStopGenerating: "Stop generating",
  quotationRequestChatGenerateQuotation: "Generate quotation",
  quotationRequestChatGenerateFinalQuotation: "Generate Final Quotation",
  quotationRequestChatFinalizeQuotationRequest: "Finalize Quotation Request",
  quotationRequestChatHoldToRecord: "Hold to record voice message",
  quotationRequestChatRecordingReleaseToSend: "Recording, release to send",
  quotationRequestChatRecording: "Recording...",
  quotationRequestChatSelectSessionFirst: "Please select a chat session first.",
  quotationRequestChatCancelVoiceRecording: "Cancel voice recording",
  quotationRequestChatListening: "Listening...",
  quotationRequestChatTranscribing: "Transcribing...",

  quotationRequestChatFileUploadedSuccess: "File uploaded successfully.",
  quotationRequestChatFailedCreateSession: "Failed to create chat session. Please try again.",
  quotationRequestChatFailedUploadFile: "Failed to upload file. Please try again.",
  quotationRequestChatAnswerPendingBeforeMessage:
    "Please answer the pending questions before sending another message.",
  quotationRequestChatAnswerPendingBeforeFinalize:
    "Please answer the pending questions before finalizing the quotation request.",
  quotationRequestChatFavoriteMarked: "Chat session marked as favorite",
  quotationRequestChatFavoriteUnmarked: "Chat session unmarked as favorite",
  quotationRequestChatFailedSetFavorite: "Failed to set favorite",
  quotationRequestChatFailedUnsetFavorite: "Failed to unset favorite",
  quotationRequestChatRenamedSuccess: "Chat session renamed successfully.",
  quotationRequestChatFailedRename: "Failed to rename chat session. Please try again.",
  quotationRequestChatDeletedSuccess: "Chat session deleted successfully.",
  quotationRequestChatFailedDelete: "Failed to delete chat session. Please try again.",
  quotationRequestChatAttachmentDeletedSuccess: "Attachment deleted successfully.",
  quotationRequestChatFailedDeleteAttachment: "Failed to delete attachment. Please try again.",
  quotationRequestChatSubmittedSuccess:
    "Quotation request submitted successfully! Your request is being processed.",
  quotationRequestChatFailedSubmit: "Failed to submit quotation request",
  quotationChatPdfDownloadedSuccess: "PDF downloaded successfully!",
  quotationChatFailedGeneratePdf: "Failed to generate PDF",

  quotationRequestChatSubagentRequired:
    "Please select a sub-agent user before submitting the quotation request.",
  quotationRequestChatAppUserLoading:
    "Your CRM app user profile is still loading. Please try again in a moment.",
  quotationRequestChatAppUserMismatch:
    "Your CRM app user profile does not match this chat session.",

  quotationRequestChatRenameTitle: "Rename Chat Session",
  quotationRequestChatSessionName: "Session Name",
  quotationRequestChatEnterSessionName: "Enter session name",
  quotationRequestChatSaving: "Saving...",
  quotationRequestChatSave: "Save",
  quotationRequestChatDeleteTitle: "Delete Chat Session",
  quotationRequestChatDeleteConfirm: "Are you sure you want to delete this chat session?",
  quotationRequestChatDeleteCannotUndo: "This action cannot be undone.",
  quotationRequestChatDeleting: "Deleting...",
  quotationRequestChatDelete: "Delete",

  quotationRequestChatAttachmentsTitle: "Quotation Request Chat Attachments",
  quotationRequestChatLoadingAttachments: "Loading attachments...",
  quotationRequestChatNoAttachments: "No attachments found",
  quotationRequestChatDeleteAttachment: "Delete attachment",
  quotationRequestChatUploadingAttachment: "Uploading attachment...",
  quotationRequestChatUploadingAttachmentWait: "Please wait while your file is being uploaded.",

  quotationRequestChatAnswerPendingQuestions: "Answer Pending Questions",
  quotationRequestChatProposeOwnAnswer: "Propose my own answer",
  quotationRequestChatTypeOwnAnswerPlaceholder: "Type your own answer...",
  quotationRequestChatAnsweredOfTotal: "{{answered}} of {{total}} answered",
  quotationRequestChatReadyToSubmit: "Ready to submit",
  quotationRequestChatSubmitAll: "Submit all",
  quotationRequestChatRespondToOneQuestion: "Respond to {{count}} question",
  quotationRequestChatRespondToManyQuestions: "Respond to {{count}} questions",

  quotationRequestChatFinalizeTitle: "Finalize Quotation Request",
  quotationRequestChatLoadingSessionData: "Loading session data...",
  quotationRequestChatErrorLoadingSession: "Error loading session data. Please try again.",
  quotationRequestChatQuotationTitle: "Quotation Title",
  quotationRequestChatExtraComments: "Extra Comments",
  quotationRequestChatSubmitting: "Submitting...",
  quotationRequestChatSubmit: "Submit",
  quotationRequestChatSubmittingOverlayTitle: "Submitting quotation request...",
  quotationRequestChatSubmittingOverlayDescription:
    "Please wait while your quotation request is being submitted.",

  quotationRequestChatSelectSubagent: "Select Sub-agent",
  quotationRequestChatSearchSubagents: "Search sub-agents...",
  quotationRequestChatLoadingSubagents: "Loading sub-agents...",
  quotationRequestChatNoSubagentsFound: "No sub-agents found",
  quotationRequestChatNoSubagentsAvailable: "No sub-agents available",
  quotationRequestChatSelectedSubagent: "Selected: {{label}}",

  quotationRequestChatSubagentUsers: "Sub-agent Users",
  quotationRequestChatSearchUsers: "Search users...",
  quotationRequestChatNoUsersFound: "No users found",
  quotationRequestChatNoUsersAvailable: "No users available",

  quotationChatDownloadSummaryTitle: "Download Your Quotation Summary",
  quotationChatDownloadSummaryDescription:
    "Fill in your details below to generate a personalized PDF summary of your trip quotation. The PDF will include all trip details, destinations, transportation information, and day-by-day itinerary.",
  quotationChatCustomerTitle: "Title",
  quotationChatSelectTitle: "Select title",
  quotationChatHonorificMr: "Mr.",
  quotationChatHonorificMrs: "Mrs.",
  quotationChatHonorificMs: "Ms.",
  quotationChatHonorificDr: "Dr.",
  quotationChatHonorificProf: "Prof.",
  quotationChatCustomerPhone: "Phone",
  quotationChatCustomerCompany: "Company",
  quotationChatCustomerMessage: "Message",
  quotationChatCustomerCountry: "Country",
  quotationChatGenerating: "Generating...",
  quotationChatDownloadPdf: "Download PDF",

  quotationChatTripSummary: "Trip Summary",
  quotationChatDownloadAsPdf: "Download as PDF",
  quotationChatNoTripSummary: "No trip summary available for this session.",

  quotationRequestChatThinking: "Thinking...",
  quotationRequestChatSources: "Sources",
  quotationRequestChatSearchingWebFor: 'Searching the web for: "{{query}}"...',
  quotationRequestChatServicesByTourOperator: "Services Executed by Tour Operator",
  quotationRequestChatServicesByCustomer: "Services Handled by Customer",
  quotationRequestChatReadyNotice:
    "You can now generate a quotation for this request by clicking the button on the right.",
  quotationRequestChatGenerateFinalQuotationAria: "Generate final quotation",

  quotationRequestChatMaybeYouWantToAsk: "Maybe you want to ask:",
  quotationRequestChatClickToSendSuggestion: "Click to send this message",

  quotationRequestChatAddToFavorites: "Add to favorites",
  quotationRequestChatRemoveFromFavorites: "Remove from favorites",
  quotationRequestChatSubmitted: "Submitted",

  quotationRequestChatQuotationRequest: "Quotation Request: {{reference}}",
  quotationRequestChatQuotationTooltipTitle: "{{title}}",
  quotationRequestChatQuotationTooltipStatus: " - Status: {{status}}",

  quotationChatLoading: "Loading...",
  quotationChatSessionNotFound: "Chat session not found for this quotation",
  quotationChatMemberSessionNotFound: "Member session not found for your account",
  quotationChatUnableToConnect: "Unable to connect to chat",
  quotationChatConnecting: "Connecting...",
  quotationChatTypeYourMessage: "type your message...",
  quotationChatConnected: "Connected",
  quotationChatConnectingStatus: "Connecting...",
  quotationChatDisconnected: "Disconnected",
};

export default quotationChat;
